import {action, makeObservable, observable} from 'mobx';
import {showAlert, showWarning} from '../../helpers/alerts';
import {api} from '../../ApiFacade';
import {showLoaderAsync} from '../../helpers/loaders';
import {AppRoutes} from '../../routing/AppRoutes';
import {redirectTo} from '../../routing/browserHistory';

export class ResetPasswordState {
    email: string | null = '';
    token: string | null = '';
    @observable
    password: string = '';
    @observable
    confirmPassword: string = '';
    @observable
    invalidData = false;


    constructor() {
        makeObservable(this);
        const searchParams = new URLSearchParams(window.location.search);
        this.email = searchParams.get('email');
        this.token = searchParams.get('token');

        if (!this.email || !this.token) {
            showWarning('Invalid link', 'Please generate new password reset link');
            redirectTo(AppRoutes.Login);
        }
    }

    @action
    setEmail(v: string) {
        this.email = v;
    }

    @action
    setPassword(v: string) {
        this.password = v;
    }

    @action
    setConfirmPassword(v: string) {
        this.confirmPassword = v;
    }


    @action
    resetPassword() {
        if (
            !this.password ||
            !this.confirmPassword ||
            this.password !== this.confirmPassword
        ) {
            this.invalidData = true;
            return;
        }

        if (this.password.length < 12) {
            showWarning('Password too short', 'Password must be at least 12 letters long');
            this.invalidData = true;
            return '';
        }

        showLoaderAsync(api().userAuth.userAuthChangepasswordwithtokenPost({
            resetPasswordRequest: {
                email: this.email,
                password: this.password,
                token: this.token,
            }
        }).then(() => {
            showAlert('Success!', 'Password changed', 'success');
            redirectTo(AppRoutes.Login);
        }).catch((e) => {
            console.error('Cannot reset password', e);
            showAlert('Failed!', 'Invalid token. Please try again or contact us.', 'error');
        }));

    }
}
